/**
 * Query client and key factory.
 *
 * Keys are centralised so that invalidation after a mutation is a single call
 * rather than a guess about which string another file used.
 */

import { QueryClient } from '@tanstack/react-query'

export const queryKeys = {
  me: ['me'] as const,
  inviteStatus: ['invite', 'status'] as const,
  events: ['events'] as const,
  event: (eventId: string) => ['events', eventId] as const,
  eventRounds: (eventId: string) => ['events', eventId, 'rounds'] as const,
  /** Every share-link answer, whichever token it belongs to. */
  shared: ['shared'] as const,
  sharedEvent: (shareToken: string) => ['shared', shareToken] as const,
  sharedParticipants: (shareToken: string) => ['shared', shareToken, 'participants'] as const,
  sharedRounds: (shareToken: string) => ['shared', shareToken, 'rounds'] as const,
  sharedRound: (shareToken: string, round: number) => ['shared', shareToken, 'rounds', round] as const,
  sharedVotes: (shareToken: string, round: number) => ['shared', shareToken, 'votes', round] as const,
  sharedComments: (shareToken: string) => ['shared', shareToken, 'comments'] as const,
  sharedCalendar: (shareToken: string) => ['shared', shareToken, 'calendar'] as const,
  weather: (city: string, date: string) => ['weather', city, date] as const,
  myParticipant: (shareToken: string) => ['shared', shareToken, 'me'] as const,
  /** Every stored departure point, for invalidating the whole search. */
  anchors: ['anchors'] as const,
  departureAnchors: (query: string) => ['anchors', query] as const,
  sharedDepartures: (shareToken: string) => ['shared', shareToken, 'departures'] as const,
  sharedDepartureOptions: (shareToken: string) => ['shared', shareToken, 'departure-options'] as const,
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
